module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/bg_story_card-b82d983ff69d969d09f684f47a5a99a4.svg";